import { supabase } from '../lib/supabase'

// ========================================
// ツアー完了状態の管理（データベース + localStorage ハイブリッド）
// ウェルカム動画モーダルの表示判定に使用
// ========================================

const TOUR_COMPLETED_KEY = 'tastack_tour_completed'

/**
 * ツアー完了状態を確認（ローカルキャッシュを優先）
 */
export function isTourCompletedLocal(): boolean {
  return localStorage.getItem(TOUR_COMPLETED_KEY) === 'true'
}

/**
 * データベースからツアー完了状態を取得
 */
export async function checkTourCompletedFromDB(userId: string): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('tour_completed')
      .eq('id', userId)
      .single()

    if (error) {
      console.error('Error checking tour status:', error)
      return false
    }

    const isCompleted = data?.tour_completed === true

    // ローカルキャッシュも更新
    if (isCompleted) {
      localStorage.setItem(TOUR_COMPLETED_KEY, 'true')
    }

    return isCompleted
  } catch (error) {
    console.error('Error checking tour status:', error)
    return false
  }
}

/**
 * ツアー完了状態をマーク（データベース + ローカル両方）
 */
export async function markTourCompleted(userId?: string): Promise<void> {
  // ローカルストレージに保存（即時反映）
  localStorage.setItem(TOUR_COMPLETED_KEY, 'true')

  // データベースにも保存（アカウント単位で永続化）
  if (userId) {
    try {
      const { error } = await supabase
        .from('user_profiles')
        .update({ tour_completed: true })
        .eq('id', userId)

      if (error) {
        console.error('Error marking tour completed:', error)
      }
    } catch (error) {
      console.error('Error marking tour completed:', error)
    }
  }
}

/**
 * ツアー状態をリセット（ローカルのみ - 手動ツアー開始用）
 */
export function resetTourStatusLocal(): void {
  localStorage.removeItem(TOUR_COMPLETED_KEY)
}
